module.exports = __webpack_public_path__ + "img/8.b86e0b0c.webp";